import moment from 'moment';

/**
 * Generic, operation-agnostic types shared by the records list-view toolkit
 * (Applications, Work Orders, Invoices, and future record modules). Relocated
 * out of `screens/Applications&WorkOrders/Components/types.ts` so both features
 * depend on them as peers.
 */

export enum SORT_BY_VALUES {
  START_DATE = 'startDate',
  NAME = 'description',
  CREATION_DATE = 'createdAt'
}

export enum SORT_ORDER_VALUES {
  ASC = 'asc',
  DESC = 'desc'
}

export interface SortConfig {
  sortBy: SORT_BY_VALUES;
  order: SORT_ORDER_VALUES;
}

export interface OperationSummaryParams {
  name?: string;
  fromDate?: string;
  toDate?: string;
  cropZoneIds?: string[];
  cropZoneMatchType?: CropZoneMatchType;
  cropSeasonIds?: string[];
  page?: number;
  size?: number;
  sorts?: SortConfig[];
  filters?: { name?: string };
  id?: string;
}

/** Error payload returned with operation summary responses when the request fails server-side. */
export interface OperationSummaryError {
  message: string;
  code: string;
  timestamp: string;
}

export interface OperationSummaryResponse<T> {
  results: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  currentPage: number;
  numberOfElements: number;
  errors: OperationSummaryError | null;
}

/** How selected crop zones combine when filtering records by properties. */
export enum CropZoneMatchType {
  ANY = 'ANY',
  ALL = 'ALL'
}

/** A crop zone selected in the properties filter. */
export interface CropZoneFilterItem {
  id: string;
  name: string;
  area?: number;
  fieldName?: string;
  fieldId?: string;
  [key: string]: any;
}

/**
 * Filter-drawer form state shared by the records filter drawer. Every record
 * kind filters by `dateRange`; the properties / crop-zone dimensions are only
 * used by Applications & Work Orders (populated by the shared FilterDrawer's
 * PropertiesFilterSection) and are therefore optional. The Invoices redesign
 * uses its own drawer and never populates them.
 */
export interface FilterFormikData {
  dateRange: [moment.Moment, moment.Moment] | [];
  cropZoneIds?: string[];
  cropZones?: CropZoneFilterItem[];
  totalArea?: number | null;
  sourceType?: string | null;
  matchType?: CropZoneMatchType;
}
